/* Skinny Genie redesign: full cart page quantity/remove actions and the order
   note. Quantity changes reload the page after the change so the
   server-rendered totals stay correct (simpler and more robust than
   re-implementing every summary calculation in JS). */

function cartNoteEl(){
  return document.getElementById('cart-note');
}

/* Saves the note to the cart. Returns a promise so callers can wait for it.

   This exists because of the reload above: the note is a plain textarea inside
   the checkout form, so a form submit carries it, but pressing plus or minus
   reloads the page and anything typed but not yet saved would be thrown away.
   cartPageChangeQty therefore saves first and only then changes the quantity.

   data-saved holds the last value the server has, so repeated blurs with no
   edit do not fire pointless requests. */
function cartSaveNote(){
  var el = cartNoteEl();
  if(!el || el.value === el.getAttribute('data-saved')) return Promise.resolve();
  var value = el.value;
  return fetch(window.routes.cart_update_url + '.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({note: value})
  }).then(function(){
    el.setAttribute('data-saved', value);
    var status = document.getElementById('cart-note-status');
    if(status){
      status.textContent = 'Saved';
      clearTimeout(window.SG_NOTE_TIMER);
      window.SG_NOTE_TIMER = setTimeout(function(){ status.textContent = ''; }, 2500);
    }
  }).catch(function(){
    /* Never block a quantity change on a failed note save. The note is still in
       the textarea and still inside the checkout form, so it is not lost. */
  });
}

/* Delegated so it works regardless of when the section renders. change fires on
   blur, which is the moment the customer has finished typing. */
document.addEventListener('change', function(event){
  if(event.target && event.target.id === 'cart-note') cartSaveNote();
});

function cartPageChangeQty(key, quantity){
  cartSaveNote().then(function(){
    return fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({id: key, quantity: quantity})
    });
  }).then(function(){ window.location.reload(); });
}
